import type { AssetClassification, InfoAssetType } from './types';

export const INFO_ASSET_TYPE_LABEL: Record<InfoAssetType, string> = {
  informacion: 'Información',
  software: 'Software',
  hardware: 'Hardware',
  servicio: 'Servicio',
  personas: 'Personas',
  instalaciones: 'Instalaciones',
};

export const ASSET_CLASSIFICATION_LABEL: Record<AssetClassification, string> = {
  publica: 'Pública',
  interna: 'Interna',
  confidencial: 'Confidencial',
  restringida: 'Restringida',
};

export function classificationBadgeClass(value: AssetClassification): string {
  switch (value) {
    case 'publica':
      return 'bg-emerald-100 text-emerald-800';
    case 'interna':
      return 'bg-sky-100 text-sky-800';
    case 'confidencial':
      return 'bg-amber-100 text-amber-900';
    case 'restringida':
      return 'bg-rose-100 text-rose-800';
    default:
      return 'bg-muted text-muted-foreground';
  }
}

export function formatCia(c: number, i: number, a: number): string {
  return `C${c} · I${i} · A${a}`;
}
